import React, { Component } from 'react';
import { connect } from 'react-redux';

import { openModal } from 'actions/modalActions';
import {
  ADD_EXCHANGE_RATE,
  EDIT_EXCHANGE_RATE,
  REMOVE_EXCHANGE_RATE,
} from 'constants/actionTypes';
import { periodColumnsExchangeRatesSelector } from 'selectors/periods';
import exchangeRateRowsSelector from 'selectors/exchangeRateRows';

import { Grid } from 'components/shared/Grid';
import { DEFAULT_EXCHANGE_RATE } from 'utils/stateToState';

class ExchangeRatesModal extends Component {
  get columnDefs() {
    return [...this.props.periods];
  }

  getContextMenuItems = (params) => {
    const hasSelectedNodes = params.api.getSelectedNodes().length;

    const contextMenuItems = [
      {
        name: 'New Exchange Rate',
        action: () => this.props.addExchangeRate(),
      },
      {
        name: 'Remove Selected Exchange Rates',
        disabled: !params.node || !hasSelectedNodes,
        action: () => {
          params.api.getSelectedNodes().forEach((node) => {
            this.props.removeExchangeRate(node.data.id);
          });
        },
      },
    ];

    return contextMenuItems;
  };

  handleCellValueChanged = (event) => {
    this.props.editExchangeRate(event.data);
  };

  processCellFromClipboard = (params) => {
    const valueParser = params?.column?.userProvidedColDef?.valueParser;

    if (valueParser) {
      const colId = params?.column?.userProvidedColDef?.colId;
      const oldValue = params?.node?.data?.[colId];

      return valueParser({
        oldValue: oldValue || DEFAULT_EXCHANGE_RATE,
        newValue: params.value,
      });
    }

    return params.value;
  };

  render() {
    return (
      <div className="ExchangeRatesModal">
        <h2>Exchange rates</h2>
        <div className="exchange-rates-grid">
          <Grid
            columnDefs={this.columnDefs}
            rowData={this.props.rows}
            rowSelection="multiple"
            rowDeselection={true}
            getContextMenuItems={this.getContextMenuItems}
            onCellValueChanged={this.handleCellValueChanged}
            processCellFromClipboard={this.processCellFromClipboard}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  periods: periodColumnsExchangeRatesSelector(state),
  rows: exchangeRateRowsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addExchangeRate: () => dispatch({ type: ADD_EXCHANGE_RATE }),
  editExchangeRate: (exchangeRate) =>
    dispatch({ type: EDIT_EXCHANGE_RATE, exchangeRate }),
  removeExchangeRate: (exchangeRateId) =>
    dispatch({ type: REMOVE_EXCHANGE_RATE, exchangeRateId }),
  openModal: (modalConfig) => dispatch(openModal(modalConfig)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeRatesModal);
